/** PURE_IMPORTS_START .._.._Observable,.._.._operator_startWith PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { startWith } from '../../operator/startWith';
Observable.prototype.startWith = startWith;
//# sourceMappingURL=startWith.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/operator/startWith.js
// module id = 583
// module chunks = 0